import { isAxiosError } from 'axios'

/** What to show for a failed API call. The backend sends `reason`; `message` is kept for gateways and proxies. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (!isAxiosError(err)) return fallback
  const data = err.response?.data as { reason?: string; message?: string } | undefined
  return data?.reason || data?.message || fallback
}

/** The backend refused a new account because the beta user cap is reached. Existing users are never refused. */
export function isSignupsClosed(err: unknown): boolean {
  if (!isAxiosError(err)) return false
  return (err.response?.data as { reason?: string } | undefined)?.reason === 'signups_closed'
}
